import { memo, useEffect, useState } from "react";

export type LoadingProps = {
  startColour?: string;
  finalColour?: string;
  relativeSizing?: boolean;
};

export const Loading = memo(
  ({ startColour = "platform-100", finalColour = "platform-700", relativeSizing = false }: LoadingProps) => {
    const [color, setColor] = useState(startColour);

    useEffect(() => {
      const timer = setInterval(() => {
        setColor(color === finalColour ? startColour : finalColour);
      }, 500);
      return () => {
        clearInterval(timer);
      };
    }, [color]);

    const dotSize = relativeSizing ? "w-[0.75em] h-[0.75em] p-[0.25em]" : "w-3 h-3 p-1";
    return (
      <div className={`justify-center flex`} data-testid="Loading">
        {/** classes have been added here so they are not tree shaken... */}
        <span className="sr-only bg-brand-800 bg-[#000000]">Loading</span>
        <div
          className={`bg-${color} block ${dotSize} rounded-full duration-100 transition-colors ease-in-out`}
          data-testid="loadingDot"
        ></div>
        <div
          className={`bg-${color} block ${dotSize} ${
            relativeSizing ? "mx-[0.25em]" : "mx-1"
          } rounded-full delay-100 duration-100 transition-colors ease-in-out`}
          data-testid="loadingDot"
        ></div>
        <div
          className={`bg-${color} block ${dotSize} rounded-full blue-circle delay-200 duration-100 transition-colors ease-in-out`}
          data-testid="loadingDot"
        ></div>
      </div>
    );
  }
);

Loading.displayName = "Loading";
